import React, { useReducer } from "react";

import axiosClient from "../../config/axios";
import BillReducer from "./BillReducer";
import BillContext from "./BillContext";
import {
    ERROR,
    FETCH_COMPLETED,
    PUSH_COMPLETED ,
    DELETE_COMPLETED,
    UPDATE_COMPLETED,
    SET_CURRENT_TYPE,
    SET_HISTORY,
    SET_CURRENT_ITEM,
    GET,
    POST,
    PUT,
    DELETE,
    SET_BILL_GET_ALL_PARAMS,
    EXPORT_COMPLETED,
    GET_BILL_COMPLETED,
    CLEAR
} from "./BillStates";

const BillState = (props) => {

  const [state, dispatch] = useReducer(BillReducer, {});

  async function baseAxios(url, method, data ,type=FETCH_COMPLETED, options){
     try {
          let response
          const token = localStorage.getItem('token')//TODO use the context token and header
          switch(method){
            case GET:
                 response = await axiosClient.get(url,{headers:{'Authorization':'Bearer '+token}})
            break
            case POST:
                 response = await axiosClient.post(url,data,{headers:{'Authorization':'Bearer '+token}});
            break
            default: return;//throw {error:'Not defined!'}
          }
          dispatch({
            type: type,
            payload: response.data??null,
            options:options??null
          });
    } catch (error) {
        //console.error(error)
        dispatch({
          type: ERROR,
          payload:error,
          options:options??null
        })
    }
  }
  const getBillAll = async (CustomerId, //MANDATORY
                            ShopId,//MANDATORY
                            Type=null, //FACTURA ELECTRÓNICA
                            From=null,
                            Until=null,
                            CurrentPage=1,
                            MaxPerPage=10,
                            FilterCriteria=null
                            ) => {
        try {
          if(!CustomerId) throw {errorMessage:"getBill->CustomerId missing"}
          if(!ShopId) throw {errorMessage:"getBill->ShopId missing"}

          let url = `/getBillAll?CustomerId=${CustomerId}&ShopId=${ShopId}`
          if(From)url +=`&From=${From}`
          if(Type)url +=`&Type=${Type}`
          if(Until)url +=`&Until=${Until}`
          if(CurrentPage)url +=`&CurrentPage=${CurrentPage}`
          if(MaxPerPage)url +=`&MaxPerPage=${MaxPerPage}`
          if(FilterCriteria)url +=`&FilterCriteria=${FilterCriteria}`

          baseAxios(url,GET,null,FETCH_COMPLETED,{MaxPerPage})//TODO use custom event type
        } catch (error) {
            //console.error(error)
            dispatch({
              type: ERROR,
              payload:error
            })
        }
    }
  const getBill = async (customerId,shopId,billId) => {
      try {
        if(!customerId) throw {errorMessage:"getBill->customerId missing"}
        if(!shopId) throw {errorMessage:"getBill->type missing"}
        if(!billId) throw {errorMessage:"getBill->billId missing"}
        const url = `/Bill?CustomerId=${customerId}&ShopId=${shopId}&Id=${billId}`
        baseAxios(url,GET,null,GET_BILL_COMPLETED)
      } catch (error) {
          //console.log(error)
          dispatch({
            type: ERROR,
            payload:error
          })
      }
  }
  const postBill = (payload) => {
    try {
      baseAxios("/Bill",POST, payload,PUSH_COMPLETED)
    } catch (error) {
        //console.log(error)
        dispatch({
          type: ERROR,
          payload:error
        })
    }
  }
  const exportBill = (CustomerId,ShopId) => {
      try {
        baseAxios("/BillExport",POST, {CustomerId,ShopId},EXPORT_COMPLETED)
      } catch (error) {
          //console.log(error)
          dispatch({
            type: ERROR,
            payload:error
          })
      }
    }

  const setCurrentType = (currentType)=>{
       dispatch({
         type: SET_CURRENT_TYPE,
         payload:{currentType}
       });
   }
  const setHistory = (history)=>{
          dispatch({
            type: SET_HISTORY,
            payload:{history}
          });
      }
  const setCurrentItem = (currentItemId)=>{
          dispatch({
            type: SET_CURRENT_ITEM,
            payload:{currentItemId}
          });
      }

  const setBillAllParams=(params)=>{
    dispatch({
        type: SET_BILL_GET_ALL_PARAMS,
        payload:params
    });
  }
  const clear=()=>{
    dispatch({
        type: CLEAR
    })
  }
  return (
    <BillContext.Provider
      value={{
        ...state,
        setCurrentType,
        setCurrentItem,
        setHistory,
        getBill,
        getBillAll,
        postBill,
        setBillAllParams,
        exportBill,
        clear,
      }}
    >
      {props.children}
    </BillContext.Provider>
  );
};

export default BillState;
